//@flow
export const isPlanLoading = state => {
    return state.fpPlanView.getIn(['plan', 'isLoading']);
};

export const getFpPlan = state => {
    return state.fpPlanView.getIn(['plan', 'entity']);
};

export const getSalesbeatPlan = state => {
    return state.fpPlanView.getIn(['salesbeatPlan', 'entity']);
};

export const isSalesbeatPlanLoading = state => {
    return state.fpPlanView.getIn(['salesbeatPlan', 'isLoading']);
};

export const getOutletSalesCategories = state => {
    return state.fpPlanView.getIn(['outletSalesCategories', 'entity']);
};

export const getVisitIdMap = state => {
    return state.fpPlanView.get('visitIdMap');
};
